/**
 * Created by comoon on 2/22/16.
 */


function reverse(string) {

    return string.split("").reverse().join("");
}

function format(price) {

    if (!price && (price !== 0)) {

        return "0";
    }

    if (parseInt(price) !== price) {

        price = price + "";

        var pointIndex = price.indexOf(".");

        return formatWhole(price.substring(0, pointIndex)) + "." + formatChange(price.substring(pointIndex + 1));

    } else {

        return formatWhole(price + "");
    }
}

function formatWhole(whole) {

    return reverse(formatChange(reverse(whole)));
}

function formatChange(change) {

    var result = [];

    while (change.length > 0) {

        var len = Math.min(3, change.length);

        result.push("," + change.substr(0, len));

        change = change.substring(len);
    }

    return result.join("").substring(1);
}


module.exports = {
    format
};


/** WEBPACK FOOTER **
 ** ./script/util/price.js
 **/